import { EmptyComponent } from '@/router/modules/empty'

export default [
  {
    path: 'daftar',
    name: 'report purchase list',
    component: () => import('@/views/app/report-purchase/list/page-list.vue'),
    meta: { title: 'Laporan Daftar Pembelian' },
  },
  {
    path: 'rekap',
    name: 'report purchase summary',
    component: () => import('@/views/app/report-purchase/summary/page-list.vue'),
    meta: { title: 'Laporan Rekap Pembelian' },
  },
  {
    path: 'data',
    name: 'report purchase data',
    component: () => import('@/views/app/report-purchase/by-data/page-list.vue'),
    meta: { title: 'Laporan Data Pembelian' },
  },
  {
    path: 'per-nota',
    name: 'report purchase per invoice',
    component: () => import('@/views/app/report-purchase/by-nota/page-list.vue'),
    meta: { title: 'Laporan Pembelian per Nota' },
  },
  {
    path: 'per-product',
    name: 'report purchase per product',
    component: () => import('@/views/app/report-purchase/by-item/page-list.vue'),
    meta: { title: 'Laporan Pembelian per Produk' },
  },
  {
    path: 'per-supplier',
    name: 'report purchase per supplier',
    component: () => import('@/views/app/report-purchase/by-supplier/page-list.vue'),
    meta: { title: 'Laporan Pembelian per Supplier' },
  },
  {
    path: 'retur',
    name: 'report purchase return',
    component: EmptyComponent,
    meta: { title: 'Laporan Retur Pembelian' },
  },
  {
    path: 'pembayaran',
    name: 'report purchase payment',
    component: EmptyComponent,
    meta: { title: 'Laporan Pembayaran Pembelian' },
  },
  {
    path: 'hutang-dagang',
    name: 'report purchase debt',
    component: EmptyComponent,
    meta: { title: 'Laporan Hutang Dagang' },
  },
]
